module.exports = __webpack_public_path__ + "static/media/yiyuan11.d0ddc8da.png";